import React from 'react';

import { Landing } from 'containers';

export const HomeAuthenticated = () => <Landing />;

export default HomeAuthenticated;
